/*
 * Fixes same-page anchor links (e.g. href="#pd") landing short of their
 * target on long pages with lazy-loaded images/video/carousels.
 *
 * The browser's native anchor jump calculates the target's position once,
 * at click time. If content above the target is still loading (lazy images,
 * async carousel libraries, etc.), the page keeps growing after the jump
 * and the user lands short. This intercepts the click and keeps correcting
 * the scroll position for a few seconds until the layout settles, or until
 * the user manually scrolls (so it never fights a real user interaction).
 */
(function () {
  function findTarget(id) {
    return document.getElementById(id) || document.getElementsByName(id)[0] || null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash.length < 2) return;

    var id = decodeURIComponent(hash.slice(1));
    var target = findTarget(id);
    if (!target) return;

    e.preventDefault();

    var maxDuration = 3000;
    var settleThreshold = 2;
    var requiredStableFrames = 6;
    var startTime = Date.now();
    var lastY = null;
    var stableCount = 0;
    var stopped = false;

    function stop() {
      if (stopped) return;
      stopped = true;
      window.removeEventListener('wheel', onUserInterrupt);
      window.removeEventListener('touchmove', onUserInterrupt);
      window.removeEventListener('keydown', onUserInterrupt);
    }

    function onUserInterrupt() {
      stop();
    }

    window.addEventListener('wheel', onUserInterrupt, { passive: true });
    window.addEventListener('touchmove', onUserInterrupt, { passive: true });
    window.addEventListener('keydown', onUserInterrupt);

    function step() {
      if (stopped) return;

      var rect = target.getBoundingClientRect();
      var targetY = Math.max(0, Math.round(window.scrollY + rect.top));

      if (lastY === null || Math.abs(targetY - lastY) > settleThreshold) {
        window.scrollTo({ top: targetY, behavior: lastY === null ? 'smooth' : 'auto' });
        lastY = targetY;
        stableCount = 0;
      } else {
        stableCount++;
      }

      if (Date.now() - startTime < maxDuration && stableCount < requiredStableFrames) {
        requestAnimationFrame(step);
      } else {
        stop();
      }
    }

    requestAnimationFrame(step);
  });
})();
